import { render, staticRenderFns } from "./gj-upload-attacth.vue?vue&type=template&id=66bbe236&scoped=true&"
import script from "./gj-upload-attacth.vue?vue&type=script&lang=js&"
export * from "./gj-upload-attacth.vue?vue&type=script&lang=js&"
import style0 from "./gj-upload-attacth.vue?vue&type=style&index=0&id=66bbe236&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bbe236",
  null
  
)

export default component.exports